import axios from 'axios';
import { API } from './api';
import { greetName, renderMessage, sharePdfToWhatsApp } from './waShare';

const inr = (n) => Number(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// WhatsApp thank-you after an invoice payment, with the updated (paid / part-paid) invoice PDF.
// gst: GST invoice (balance nets the upfront advance) vs plain invoice (total_due is already net).
export async function sendPaymentThanks({ invoice, payment, gst, customer, authHeader }) {
  const base = `${API}/${gst ? 'gst' : 'billing'}/invoices/${invoice.id}`;
  const total = Number(gst ? invoice?.totals?.grand_total ?? invoice.total_due ?? 0 : invoice.total_due ?? 0);
  const paid = Number(invoice.amount_paid || 0);
  const balance = Math.max(0, total - paid - (gst ? Number(invoice.advance_received || 0) : 0));
  let pdfLink = '';
  try {
    const { data } = await axios.post(`${base}/share-link`, {}, { headers: authHeader() });
    if (data?.pdf_url) pdfLink = data.pdf_url.startsWith('http') ? data.pdf_url : `${window.location.origin}${data.pdf_url}`;
  } catch { /* message still goes without a link */ }
  let payLink = '';
  if (balance > 0) {
    try {
      const { data } = await axios.get(`${API}/payments/${gst ? 'gst' : 'invoice'}/${invoice.id}/pay-link`, { headers: authHeader() });
      payLink = data?.pay_url || '';
    } catch { /* no gateway */ }
  }
  const c = customer || invoice.customer_snapshot || {};
  const number = invoice.number || invoice.id.slice(0, 8);
  const full = invoice.status === 'paid' || balance <= 0.005;
  const docType = gst ? 'GST tax invoice' : 'invoice';
  const vals = {
    customer: greetName(c.prefix, c.name), number, doc_type: docType, for_subject: invoice.subject ? ` for ${invoice.subject}` : '',
    amount: inr(payment?.amount), paid: inr(paid), balance: inr(balance), total: inr(total), pdf_link: pdfLink, pay_link: payLink, upi: '',
  };
  const message = renderMessage(full ? 'invoice_paid' : 'payment_received', vals)
    || (full ? `Thank you! Your ${docType} ${number} is paid in full (₹ ${vals.total}).`
      : `Thank you! We have received ₹ ${vals.amount} against ${docType} ${number}. Balance due: ₹ ${vals.balance}.`);
  const suffix = full ? '_PAID' : '_PARTIALLY_PAID';
  await sharePdfToWhatsApp({
    getPdf: async () => (await axios.get(`${base}/pdf`, { responseType: 'blob', headers: authHeader() })).data,
    filename: `${gst ? 'GST_' : 'Invoice_'}${String(number).replace(/\//g, '_')}${suffix}.pdf`,
    title: `${gst ? 'GST Invoice' : 'Invoice'} ${number}`, message, phone: c.phone || '', kind: 'Invoice',
  });
}
